import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Lock, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-brand-cream border-t border-brand-border relative overflow-hidden" data-id="element-145">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-146">
        <FadeIn className="text-center mb-12" data-id="element-147">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-4 leading-tight" data-id="element-148">
            TU DECISIÓN HOY
          </h2>
          <p className="text-lg text-brand-muted mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-149">
            Podés seguir mañana igual que hoy: Hinchada. Agotada. Al borde del
            límite.
          </p>
          <p className="text-xl font-bold text-brand-accent mb-8" data-id="element-150">
            O podés empezar en 5 minutos.
          </p>
        </FadeIn>

        {/* Main urgent CTA */}
        <FadeIn delay={0.05} data-id="element-151">
          <div className="flex flex-col items-center text-center mb-10" data-id="element-152">
            <Button href="https://librofy-store.myshopify.com/checkouts/cn/hWNC5X2P2PkCUJbS8YPpTCfx/es-ar?_r=AQAB1UPdc-8veqwkFNY9jRjuDbNWVeiM_7gIUxb_I2G_GIo&preview_theme_id=160306823389" variant="urgent" size="xl" className="w-full sm:w-auto max-w-xl" data-id="element-153">
              ACCEDER AHORA A MEGAPACK
            </Button>
            <p className="mt-4 text-base md:text-lg font-medium text-brand-muted flex items-center gap-2" data-id="element-154">
              <span data-id="element-155">⏰</span>
              <span data-id="element-156">Acceso inmediato en 2 minutos</span>
            </p>
          </div>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-157">
          {/* Tier 1 */}
          <FadeIn delay={0.1} data-id="element-158">
            <div className="bg-brand-card border border-brand-border rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 shadow-card" data-id="element-159">
              <div data-id="element-160">
                <h3 className="text-xl font-bold text-brand-dark mb-1" data-id="element-161">
                  📘 OPCIÓN 1 — MEGAPACK
                </h3>
                <p className="text-brand-muted text-sm mb-3" data-id="element-162">
                  3 Tomos + 3 Checklists
                </p>
                <div className="inline-flex items-baseline gap-2 bg-brand-cream border border-brand-accent/40 rounded-lg px-3 py-2" data-id="element-163">
                  <span className="text-[#AAAAAA] line-through text-sm" data-id="element-164">
                    $33.000
                  </span>
                  <span className="text-2xl font-bold text-brand-accent" data-id="element-165">
                    $19.990 ARS
                  </span>
                </div>
              </div>
              <Button href="https://librofy-store.myshopify.com/checkouts/cn/hWNC5X2P2PkCUJbS8YPpTCfx/es-ar?_r=AQAB1UPdc-8veqwkFNY9jRjuDbNWVeiM_7gIUxb_I2G_GIo&preview_theme_id=160306823389" variant="outline" className="w-full md:w-auto whitespace-nowrap" data-id="element-166">
                → QUIERO MI MEGAPACK
              </Button>
            </div>
          </FadeIn>

          {/* Tier 2 */}
          <FadeIn delay={0.2} data-id="element-167">
            <div className="bg-brand-cream border-2 border-brand-terracotta rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 shadow-card" data-id="element-168">
              <div data-id="element-169">
                <h3 className="text-xl font-bold text-brand-dark mb-1" data-id="element-170">
                  🏆 OPCIÓN 2 — MEGAPACK PREMIUM ⭐
                </h3>
                <p className="text-brand-terracotta text-sm mb-3 font-medium" data-id="element-171">
                  3 Tomos + 3 Checklists + 3 Bonos Exclusivos
                </p>
                <div className="inline-flex items-baseline gap-2 bg-brand-cream border border-brand-accent rounded-lg px-3 py-2" data-id="element-172">
                  <span className="text-[#AAAAAA] line-through text-sm" data-id="element-173">
                    $51.000
                  </span>
                  <span className="text-3xl font-bold text-brand-accent" data-id="element-174">
                    $27.990 ARS
                  </span>
                </div>
              </div>
              <Button href="https://librofy.store/products/megapack-hinchada-cansada-nerviosa-premium" variant="terracotta" className="w-full md:w-auto whitespace-nowrap" data-id="element-175">
                → QUIERO EL PREMIUM
              </Button>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-176">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-2 text-sm text-brand-muted max-w-xl mx-auto mb-16" data-id="element-177">
            <div className="flex items-center justify-center gap-2" data-id="element-178">
              <Lock className="w-4 h-4 text-brand-accent" data-id="element-179" /> Pago 100% seguro
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-180">
              <Zap className="w-4 h-4 text-brand-accent" data-id="element-181" /> Acceso en 5 min
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-182">
              <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-183" /> Garantía 7
              días
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-184">
              <CreditCard className="w-4 h-4 text-brand-accent" data-id="element-185" /> Mercado Pago
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="text-center border-t border-brand-border pt-12" data-id="element-186">
          <div className="text-2xl font-bold text-brand-dark mb-4" data-id="element-187">
            🌿 LIBROFY.STORE™
          </div>
          <p className="text-brand-muted mb-2" data-id="element-188">
            Sistema de bienestar para mujeres argentinas.
          </p>
          <p className="text-brand-accent font-medium mb-8 italic" data-id="element-189">
            "Tu cuerpo no está roto. Solo estaba esperando el sistema correcto."
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-muted mb-12" data-id="element-190">
            <a href="mailto:hola@librofy.store" className="hover:text-brand-accent transition-colors" data-id="element-191">
              📧 hola@librofy.store
            </a>
            <span className="hover:text-brand-accent transition-colors cursor-pointer" data-id="element-192">
              📸 @librofy.store
            </span>
            <a href="https://www.librofy.store" className="hover:text-brand-accent transition-colors" data-id="element-193">
              🌐 www.librofy.store
            </a>
          </div>

          <p className="text-xs text-brand-muted mb-4" data-id="element-194">
            © LibrofyStore™ 2024 — Todos los derechos reservados.
          </p>
        </FadeIn>
      </div>
    </section>;
}